/**  @jsxImportSource @emotion/react */
import { useEffect } from "react";
import { Button } from "react-bootstrap";
import { ApiForeignCurrencyInsurancesRankResponseInsurancesInner } from "../../../../openApi/api";
import { ContentsColumnCommon } from "./ContentsColumnCommon";
import { formatTextWithLineBreaks, formatForDisplayUrlLinks } from "./utils";

interface Props {
  typeOfInsurance: number;
  insurance: ApiForeignCurrencyInsurancesRankResponseInsurancesInner;
  lowPriceRank: number;
  age: number;
  sex: number;
  setIsPopupOpen: (isPopupOpen: boolean) => void;
  setFocusedIndex: (focusedIndex: number) => void;
  insuranceListInCart: ApiForeignCurrencyInsurancesRankResponseInsurancesInner[];
  setInsuranceListInCart: (
    prevCart: ApiForeignCurrencyInsurancesRankResponseInsurancesInner[]
  ) => void;
  insuranceIdListInCart: string[];
  setInsuranceIdListInCart: (insuranceIdListInCart: string[]) => void;
  checkedRankList: string[];
  setCheckedRankList: (checkedRankList: string[]) => void;
  setIsContentsColumnRendered: (isContentsColumnRendered: boolean) => void;
  numberOfInsurances: number | undefined;
}

export const ContentsColumnForeignCurrency = ({
  typeOfInsurance,
  insurance,
  lowPriceRank,
  age,
  sex,
  setIsPopupOpen,
  setFocusedIndex,
  insuranceListInCart,
  setInsuranceListInCart,
  insuranceIdListInCart,
  setInsuranceIdListInCart,

  checkedRankList,
  setCheckedRankList,
  setIsContentsColumnRendered,
  numberOfInsurances,
}: Props) => {
  useEffect(() => {
    if (lowPriceRank === numberOfInsurances) setIsContentsColumnRendered(true);
  }, [lowPriceRank, setIsContentsColumnRendered, numberOfInsurances]);
  return (
    <div className="plan">
      <ContentsColumnCommon
        typeOfInsurance={typeOfInsurance}
        insurance={insurance}
        lowPriceRank={lowPriceRank}
        age={age}
        sex={sex}
        setIsPopupOpen={setIsPopupOpen}
        setFocusedIndex={setFocusedIndex}
        insuranceListInCart={insuranceListInCart}
        setInsuranceListInCart={setInsuranceListInCart}
        insuranceIdListInCart={insuranceIdListInCart}
        setInsuranceIdListInCart={setInsuranceIdListInCart}
        checkedRankList={checkedRankList}
        setCheckedRankList={setCheckedRankList}
      />
      <div className="listBody h75">
        {insurance.file_url && (
          <Button
            onClick={() => {
              window.open(insurance.file_url, '_blank');
            }}
            variant="orange"
            className="netBtn"
          >
            PDF
          </Button>
        )}
      </div>
      <div className="attention listBody mh50 miniText">{formatTextWithLineBreaks(insurance.summary)}</div>
      <div className="condition listBody mh50 miniText">{formatTextWithLineBreaks(insurance.remarks)}</div>
      <div className="riskUrl listBody mh50 miniText">{formatForDisplayUrlLinks(insurance.risk_url)}</div>
      <div className="approvalNumber listBody mh100 approvalText">{insurance.approval_number}</div>
    </div>
  );
};
